import { createContext } from "react";

const MenuStateContext = createContext({
  tree: [],
  currentLevel: ""
});

const MenuChangeContext = createContext({
  onBack: () => {},
  onMenuOpen: () => {}
});

export { MenuStateContext, MenuChangeContext };
